module.exports = __webpack_public_path__ + "img/create-wo-button.af202a55.svg";